import React from 'react'

import PropTypes from 'prop-types'

import './steps.css'

const Steps = (props) => {
  return (
    <div className="steps-container1 thq-section-padding">
      <div className="steps-max-width thq-section-max-width">
        <div className="steps-container2 thq-grid-2">
          <div className="steps-section-header">
            <h2 className="thq-heading-2">Power of Our Services</h2>
            <div className="steps-actions">
              <button className="thq-button-filled thq-button-animated steps-button">
                <span className="thq-body-small">Discover</span>
              </button>
            </div>
          </div>
          <div className="steps-container3">
            <div className="steps-container4 thq-card">
              <h2 className="thq-heading-2">{props.step1Title}</h2>
              <span className="steps-text13 thq-body-small">
                {props.step1Description}
              </span>
              <label className="steps-text14 thq-heading-3">01</label>
            </div>
            <div className="steps-container5 thq-card">
              <h2 className="thq-heading-2">{props.step2Title}</h2>
              <span className="steps-text16 thq-body-small">
                {props.step2Description}
              </span>
              <label className="steps-text17 thq-heading-3">02</label>
            </div>
            <div className="steps-container6 thq-card">
              <h2 className="thq-heading-2">{props.step3Title}</h2>
              <span className="steps-text19 thq-body-small">
                {props.step3Description}
              </span>
              <label className="steps-text20 thq-heading-3">03</label>
            </div>
            <div className="steps-container7 thq-card">
              <h2 className="thq-heading-2">{props.step4Title}</h2>
              <span className="steps-text22 thq-body-small">
                {props.step4Description}
              </span>
              <label className="steps-text23 thq-heading-3">04</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Steps.defaultProps = {
  step4Description:
    'Enjoy ongoing support and maintenance services to ensure optimal performance of your Cloud IT solution.',
  step1Description:
    'Schedule a consultation with our experts to discuss your IT needs and goals.',
  step3Description:
    'We will implement the solution seamlessly within your existing infrastructure.',
  step2Title: 'Solution Design',
  step3Title: 'Implementation',
  step1Title: 'Consultation',
  step4Title: 'Support & Maintenance',
  step2Description:
    'Our team will design a customized Cloud IT solution tailored to your specific requirements.',
}

Steps.propTypes = {
  step4Description: PropTypes.string,
  step1Description: PropTypes.string,
  step3Description: PropTypes.string,
  step2Title: PropTypes.string,
  step3Title: PropTypes.string,
  step1Title: PropTypes.string,
  step4Title: PropTypes.string,
  step2Description: PropTypes.string,
}

export default Steps
